const environment = {
  appVersion: "0.1.0",
  googleMapsLibraries: ["places"],
};

export default environment;
